import { gql } from '@apollo/client';

export const QUERY_LATEST_BOOKINGS = gql`
  query QUERY_LATEST_BOOKINGS {
    AdminQueries {
      getAdminDashboard {
        checkingInToday
        checkingOutToday
        createdToday
        updatedToday
      }
    }
  }
`;

export const QUERY_PENDING_REQUESTS_COUNT = gql`
  query QUERY_PENDING_REQUESTS_COUNT(
    $organizationRequestStatus: String
    $userRequestStatus: String
    $creditApplicationStatus: String
  ) {
    getPendingRequestsCount(
      organizationRequestStatus: $organizationRequestStatus
      userRequestStatus: $userRequestStatus
      creditApplicationStatus: $creditApplicationStatus
    ) {
      numberOfOrgRequests
      numberOfUserRequests
      numberOfCreditApplications
    }
  }
`;
